export const CONTRACT_CRYPTO_FLOW_URL = '/myprofile/broker/crypto'
